import {Form} from '../../../app/components/Form';
import {useGetBiotwinQuery, useUpdateBiotwinMutation} from '../../../app/services/biotwinApi';
import {useGetAdditionalsQuery, useGetSubscriptionTypesQuery} from '../../../app/services/subscriptionApi';
import {useBlockUI} from '../../core/hooks/useBlockUI';
import {PaymentType} from '../../auth/types';
import styles from './ManageSample.module.css';
export interface ManageSampleProps {
  className?: string;
  userId: number;
}
export const ManageSample = ({className, userId}: ManageSampleProps) => {
  const [updateBiotwin, {isLoading: isLoadingUpdateBiotwin}] = useUpdateBiotwinMutation();
  const {data: biotwin} = useGetBiotwinQuery(
    {
      id: userId,
    },
    {
      skip: !userId,
    },
  );
  const {data: subscriptionTypes} = useGetSubscriptionTypesQuery();
  const {data: additionals} = useGetAdditionalsQuery();
  useBlockUI(isLoadingUpdateBiotwin);
  return (
    <Form
      className={className}
      defaultValues={biotwin}
      fields={({setValue}) => [
        {
          name: 'isSample',
          label: 'Sample',
          type: 'checkbox',
          typeOptions: {
            onCheckedChange: (e) => {
              setValue('isSample', !!e);
              updateBiotwin({
                id: userId,
                changes: {
                  isSample: e === true,
                },
              })
                .unwrap()
                .catch(() => {
                  setValue('isSample', !e);
                });
            },
          },
        },
        {
          name: 'targetSubscriptionTypeIds',
          label: 'Target Subscription Type',
          type: 'multiselect',
          typeOptions: {
            className: 'w-full',
            itemTemplate: (option) => (
              <div className="flex items-center gap-2">
                <span>{option.name}</span>
                <span className="text-gray-600">
                  ({option.paymentType === PaymentType.Month ? 'Monthly' : 'Yearly'})
                </span>
              </div>
            ),
            onValueChange: (e) => {
              setValue('targetSubscriptionTypeIds', e);
              updateBiotwin({
                id: userId,
                changes: {
                  targetSubscriptionTypeIds: e,
                },
              })
                .unwrap()
                .catch(() => {
                  setValue('targetSubscriptionTypeIds', biotwin?.targetSubscriptionTypeIds ?? []);
                });
            },
            options: subscriptionTypes ?? [],
            optionLabel: 'name',
            optionValue: 'id',
            panelClassName: styles.multiSelectPanel,
            placeholder: 'Select',
            selectedItemTemplate: (value) => {
              if (!value) {
                return null;
              }
              const subscriptionType = subscriptionTypes?.find((subscriptionType) => subscriptionType.id === value);
              if (!subscriptionType) {
                return null;
              }
              return (
                <div className="flex items-center gap-2">
                  <span>{subscriptionType.name}</span>
                  <span className="text-gray-600">
                    ({subscriptionType.paymentType === PaymentType.Month ? 'Monthly' : 'Yearly'})
                  </span>
                </div>
              );
            },
            showSelectAll: false,
          },
        },
        {
          name: 'targetAdditionalIds',
          label: 'Target Additionals',
          type: 'multiselect',
          typeOptions: {
            className: 'w-full',
            itemTemplate: (option) => (
              <div className="flex items-center gap-2">
                <span>{option.name}</span>
                <span className="text-gray-600">
                  ({option.paymentType === PaymentType.Month ? 'Monthly' : 'Yearly'})
                </span>
              </div>
            ),
            onValueChange: (e) => {
              setValue('targetAdditionalIds', e);
              updateBiotwin({
                id: userId,
                changes: {
                  targetAdditionalIds: e,
                },
              })
                .unwrap()
                .catch(() => {
                  setValue('targetAdditionalIds', biotwin?.targetAdditionalIds ?? []);
                });
            },
            options: additionals ?? [],
            optionLabel: 'name',
            optionValue: 'id',
            panelClassName: styles.multiSelectPanel,
            placeholder: 'Select',
            selectedItemTemplate: (value) => {
              if (!value) {
                return null;
              }
              const additional = additionals?.find((additional) => additional.id === value);
              if (!additional) {
                return null;
              }
              return (
                <div className="flex items-center gap-2">
                  <span>{additional.name}</span>
                  <span className="text-gray-600">
                    ({additional.paymentType === PaymentType.Month ? 'Monthly' : 'Yearly'})
                  </span>
                </div>
              );
            },
            showSelectAll: false,
          },
        },
      ]}
      submitButton={false}
    />
  );
};
